import {
  apiPOST
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/tracking.ts
var recordGaData = async (model) => {
  return await apiPOST("/ga-tracking/deposit", model);
};

export {
  recordGaData
};
